import styled, { css } from 'styled-components';

// ENUMS
import { CheckBoxType } from '../../enums/checkbox';

// CONSTANTS
import { theme } from '../../constants/theme';

export const IconContainer = styled.div<{ checked: boolean; disabled: boolean; type: CheckBoxType }>`
  float: left;
  display: flex;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  align-items: center;
  justify-content: center;
  border: 2px solid ${theme.colors.states.disabled};
  width: 24px;
  min-width: 24px;
  height: 24px;
  border-radius: 6px;
  margin-right: 8px;
  box-sizing: border-box;
  color: ${theme.colors.primary.white};
  transition: 0.2s;

  ${({ type }) =>
    type === CheckBoxType.LIST &&
    css`
      border: none;
      width: 28px;
      height: 28px;
      border-radius: 25%;
      margin-right: 0;
    `};

  ${({ checked }) =>
    checked &&
    css`
      background-color: ${theme.colors.primary.bariBlue};
      border-color: ${theme.colors.primary.bariBlue};
    `}
`;

export const CheckboxStyled = styled.label<{
  type: CheckBoxType;
  disabled: boolean;
  checked: boolean;
  inModal: boolean;
}>`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;

  ${({ type, disabled, checked, inModal }) =>
    type === CheckBoxType.LIST &&
    css`
      position: relative;
      flex-direction: row-reverse;
      min-height: ${inModal ? '88px' : '68px'};
      margin-bottom: 0;
      background: ${theme.colors.primary.white};
      border: 1px solid ${theme.colors.primary.transparentBorder};
      justify-content: space-between;
      box-sizing: border-box;
      border-radius: 8px;
      padding: 15px 24px;
      align-items: center;
      z-index: 1;
      cursor: pointer;

      & + label {
        margin-top: 12px;
        margin-left: ${inModal ? 0 : 16 + 'px'};
      }

      &:hover {
        box-shadow: 0px 34px 30px -20px rgba(0, 0, 0, 0.1);
        ${IconContainer} {
          border: 2px solid ${checked ? theme.colors.primary.bariBlue : theme.colors.states.disabled};
        }
      }

      ${disabled &&
      css`
        background: ${theme.colors.primary.lightGray};
        cursor: not-allowed;
        opacity: 0.5;
      `}

      ${checked &&
      css`
        background: ${theme.colors.secondary.blue600};
        border: 2px solid ${theme.colors.primary.bariBlue};

        ::before {
          content: ' ';
          top: 0;
          left: 0;
          width: calc(100% - 4px);
          height: calc(100% - 4px);
          position: absolute;
          border: 2px solid ${theme.colors.primary.white};
          border-radius: 8px;
        }
      `}
    `}
`;

export const CheckboxHead = styled.div<{ type: CheckBoxType; icon?: boolean }>`
  display: flex;

  ${({ type, icon }) =>
    type === CheckBoxType.LIST &&
    css`
      flex-direction: column;
      margin-left: ${icon ? '10px' : '0'} ;
      }
    `};
`;

export const Title = styled.span<{ disabled: boolean; icon?: boolean; type: CheckBoxType }>`
  font-size: 14px;
  color: ${theme.colors.primary.black};

  ${({ type, disabled }) =>
    (!type || type === CheckBoxType.DEFAULT) &&
    css`
      font-family: 'Clan Pro', sans-serif;
      font-weight: ${theme.weights.regular};
      cursor: ${disabled ? 'not-allowed' : 'pointer'};
    `};

  ${({ type, icon }) =>
    type === CheckBoxType.LIST &&
    css`
      font-family: 'Clan Pro';
      font-weight: ${theme.weights.semibold};
      margin: ${icon ? '11px 8px 11px 0' : 0};
    `};
`;

export const Description = styled.p`
  margin: 0;
  font-family: 'Clan Pro', sans-serif;
  font-size: 12px;
  line-height: 20px;
  color: ${theme.colors.secondary.gray200};
  margin-top: 4px;
`;

export const Input = styled.input<{ ref?: any }>`
  display: none;

  + ${IconContainer} {
    &:not(:disabled):active {
      transform: scale(0);
    }
  }

  &:not(:disabled):hover + ${IconContainer} {
    background-color: ${theme.colors.primary.bariBlue};
    border-color: ${theme.colors.primary.bariBlue};
  }
`;

export const CheckboxHeadWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  /* flex-flow: row nowrap; */
`;

export const IconWrapper = styled.div`
  display: flex;
  place-content: center center;
  place-items: center center;
  width: 32px;
  height: 32px;
`;
